import { gql } from 'graphql-request'

class ExperienceMutations {
  deleteById = gql`
    mutation DeleteExperience($where: ExperienceWhereIdsInput!) {
      deleteExperiences(where: $where) {
        count
      }
    }
  `

  replyToExperience = gql`
    mutation replyToExperience($data: ExperienceReplyCreateInput!) {
      replyToExperience(data: $data) {
        id
        text
      }
    }
  `
}

const experienceMutations = new ExperienceMutations()

export default experienceMutations
